import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { YouTube } from 'src/components/molecules/YouTube'
import HeadTitle from 'src/components/atoms/HeadTitle'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'

export const PartnerVideo = () => {
    return (
        <Container>
            <ContentsWrapper>
                <ColumnItems>
                    <HeadTitle>３分でわかるcommmune</HeadTitle>
                    <YouTube caption="" url="https://www.youtube.com/embed/GEjhwsdvDnk"/>
                </ColumnItems>
            </ContentsWrapper>
        </Container>
    )
}

const Container = styled.div`
    background-color: ${Styles.color.primary[200]};
`

const ColumnItems = styled.div`
display: flex;
    flex-direction: column;
    padding: 30px;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        padding: 30px 50px ${Styles.spacing[13]};
        gap: ${Styles.spacing[10]};
        flex-direction: row;
    }
    @media screen and (min-width: ${BreakPoint.LAPTOP}) {
        gap: ${Styles.spacing[10]};
        padding: 30px 50px;
    }   
`
